module.exports = __webpack_public_path__ + "static/2026_kyleKnaggsResume-5a9ce75bdb9c056adb0f0334aa7dd6e0.pdf";